export enum TypeSearch {
    PARAMS = 'PARAMS',
    TEXT = 'TEXT',
}
